import { useCallback } from 'react';
import type { ChangeEvent } from 'react';
import { getCountEmojiString, truncateEmojiString } from '../helpers/emoji';

type UseEmojiLengthLimitParams = {
    value?: string;
    maxLength?: number;
    counterValue?: string;
    onChange?: (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, index?: number) => void;
    index?: number;
};

type UseEmojiLengthLimitResult = {
    resolvedCounterValue: string | undefined;
    handleChange: (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
};

export const useEmojiLengthLimit = ({
    value = '',
    maxLength,
    counterValue,
    onChange,
    index,
}: UseEmojiLengthLimitParams): UseEmojiLengthLimitResult => {
    const resolvedCounterValue =
        counterValue ?? (typeof maxLength === 'number' ? `${getCountEmojiString(value)} / ${maxLength}` : undefined);

    const handleChange = useCallback(
        (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            if (typeof maxLength === 'number' && getCountEmojiString(e.target.value) > maxLength) {
                e.target.value = truncateEmojiString(e.target.value, maxLength);
            }

            onChange?.(e, index);
        },
        [maxLength, onChange, index],
    );

    return {
        resolvedCounterValue,
        handleChange,
    };
};
